/**
 * Policy page structure.
 *
 * Shopify's policy documents are written as flat paragraphs where a section
 * name is simply the first line, followed by a <br>, followed by the body:
 *
 *   <p>Returns<br>We accept returns within 30 days of delivery…</p>
 *
 * There is no heading element anywhere, so CSS alone cannot build a hierarchy
 * — which is why the pages read as one grey wall. This promotes that leading
 * line to a real <h2> so the stylesheet has something to work with, without
 * anyone having to rewrite the policy text.
 *
 * It stands down entirely the moment the content has real headings of its own,
 * so replacing a policy with properly marked-up HTML supersedes this rather
 * than fighting it.
 *
 * Fail-open: this only ever splits an existing paragraph in two. If it never
 * runs, the page is exactly what Shopify served — styled, just flatter.
 */
(function () {
  'use strict';

  // A leading line is a heading if it looks like a label rather than a
  // sentence. The guards below are what stop "Email: support@…" and
  // "400 E. Las Colinas Blvd." being promoted.
  function looksLikeHeading(text) {
    if (!text) return false;
    if (text.length > 45) return false;
    if (text.indexOf('@') !== -1) return false;
    if (text.indexOf('http') !== -1) return false;
    if (/[.!?]$/.test(text)) return false;
    if (/\d{3}/.test(text)) return false;
    return /^[A-Z]/.test(text);
  }

  function promote(paragraph) {
    var br = paragraph.querySelector('br');
    if (!br) return;

    // Walk the nodes before the first <br> — that is the candidate line.
    var lead = '';
    var leadNodes = [];
    var node = paragraph.firstChild;
    while (node && node !== br) {
      leadNodes.push(node);
      lead += node.textContent;
      node = node.nextSibling;
    }
    if (node !== br) return;

    lead = lead.replace(/\s+/g, ' ').trim();
    if (!looksLikeHeading(lead)) return;

    var heading = document.createElement('h2');
    heading.className = 'policy-auto-heading';
    heading.textContent = lead;
    paragraph.parentNode.insertBefore(heading, paragraph);

    for (var i = 0; i < leadNodes.length; i++) {
      if (leadNodes[i].parentNode) leadNodes[i].parentNode.removeChild(leadNodes[i]);
    }
    br.parentNode.removeChild(br);

    // A paragraph that held nothing but its own title leaves an empty shell.
    if (!paragraph.textContent.trim() && !paragraph.querySelector('img, a')) {
      paragraph.parentNode.removeChild(paragraph);
    }
  }

  function init() {
    var rte = document.querySelector('.shopify-policy__body .rte');
    if (!rte) return;

    // Already structured: leave it alone rather than invent a second,
    // competing hierarchy on top of the real one.
    if (rte.querySelector('h1, h2, h3')) return;

    var paragraphs = rte.querySelectorAll('p');
    for (var i = paragraphs.length - 1; i >= 0; i--) promote(paragraphs[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
